// extracted by mini-css-extract-plugin
module.exports = {"items":"style_items__Me0gq","link":"style_link__oFhCb"};